import React from 'react';
import styled from 'styled-components';
import { blueLightCardImages } from '../Theming/images';
import { themeColor } from '../Theming';
import { ANALYTICS_PAGE_NAMES, useIsIPad } from '../Common/Analytics/utils';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import { isAndroid } from 'react-device-detect';
import { onClose } from '../TIM/KindredAndroid';
import Header from './components/Header';
import { BoldText } from './BlueLightCardPluginActivationAlwaysAllow';

const Container = styled.div<{ isIPad?: boolean }>`
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 100dvh;
  max-width: ${(props) => (props.isIPad ? '100%' : '600px')};
  margin: 0 auto;
  overflow: hidden;
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  & > img {
    width: 100%;
    height: auto;
  }
`;

const TextContainer = styled.div<{ isIPad?: boolean }>`
  padding-inline: 40px;
  margin-top: ${({ isIPad }) => (isIPad ? '120px' : '35px')};

  & > p {
    font-family: 'Museo Sans', sans-serif;
    font-weight: 400;
    font-style: 500;
    font-size: ${({ isIPad }) => (isIPad ? '25px' : '16px')};
    leading-trim: NONE;
    line-height: ${({ isIPad }) => (isIPad ? '32px' : '24px')};
    letter-spacing: 0%;
    text-align: center;
    margin: 0;
  }
`;

const BottomContent = styled.div<{ isIPad?: boolean }>`
  padding: 0 24px 34px 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex: 1;

  & > a {
    margin: 20px 0 50px 0;
    font-family: 'Museo Sans', sans-serif;
    font-weight: 600;
    font-size: ${({ isIPad }) => (isIPad ? '20px' : '16px')};
    line-height: ${({ isIPad }) => (isIPad ? '28px' : '24px')};
    letter-spacing: 0%;
    text-align: center;
    text-decoration: none;
    color: ${themeColor('blueLightCardPrimary')};
  }
`;

const Button = styled.button<{ isIPad?: boolean }>`
  background-color: ${themeColor('blueLightCardPrimary')};
  width: ${({ isIPad }) => (isIPad ? '400px' : '336px')};
  height: ${({ isIPad }) => (isIPad ? '55px' : '48px')};
  border-radius: 4px;
  opacity: 1;
  gap: 8px;
  padding: 8px 24px;
  color: ${themeColor('white')};
  font-size: ${({ isIPad }) => (isIPad ? '24px' : '18px')};
  font-weight: 600;
  border: none;
  cursor: pointer;
  margin-top: 50px;
`;

const BlueLightCardPluginActivationStartShopping = () => {
  const { activation_complete_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(activation_complete_page, 'BlueLightCard');
  const query = useQuery();
  const origin = query.get('origin');
  const isIPad = useIsIPad();

  const openBlueLightCardApp = () => {
    if (isAndroid) {
      return onClose();
    }
    window.location.href = `${origin}://`;
  };

  return (
    <Container isIPad={isIPad}>
      <Header
        height={isIPad ? 290 : 140}
        starTopPosition={'90%'}
        heading={<BoldText>Blue Light Card Deal Finder is active!</BoldText>}
      />
      <ScrollableContent>
        <TextContainer isIPad={isIPad}>
          <p>The Deal Finder will pop up</p>
          <p>whenever we find you savings.</p>
        </TextContainer>
        <img
          src={blueLightCardImages.blc_brands.default}
          alt="popular brands"
        />
        <BottomContent isIPad={isIPad}>
          <Button isIPad={isIPad} onClick={openBlueLightCardApp}>
            Back to the Blue Light Card app
          </Button>
          <a
            target="_blank"
            href="https://support.bluelightcard.co.uk/hc/en-gb/articles/38127586445713--Frequently-Asked-Questions"
            rel="noreferrer"
            className="faq"
          >
            Frequently Asked Questions
          </a>
        </BottomContent>
      </ScrollableContent>
    </Container>
  );
};

export default BlueLightCardPluginActivationStartShopping;
